/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { MonitoredObjectsStore } from '../stores/MonitoredObjectsStore';

export const MonitoredObjectsContext = createContext<MonitoredObjectsStore>({} as MonitoredObjectsStore);
